const img = require('./chevron-down-icon.png'); export default img;